import { makeAutoObservable } from 'mobx'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { isAdmin } from '../../../../../services/AccountService'
import { newAssignDealerDrawerStore } from '../../MassOperationDrawer/NewAssignDealerDrawerStore'
import store from '../../RequestsTableOptimized/RequestsTableOptimizedStore'

export const adminGroupOperations = () => [
  { name: 'ВЫБЕРИТЕ ДЕЙСТВИЕ', action: null, icon: null },
  {
    name: 'НАЗНАЧИТЬ ДИЛЕРА',
    action: () => newAssignDealerDrawerStore.setIsOpen(true),
    icon: getImageSrc('enter'),
    status: (status: number | null) => [1, 2].includes(status as number),
    invalidate: false,
  },
  {
    name: 'ПЕРЕВЕСТИ В СТАТУС СОЗДАНА',
    action: () => newAssignDealerDrawerStore.setIsResetToCreateOpen(true),
    icon: getImageSrc('massCreated'),
    status: (status: number | null) => [2, 4].includes(status as number),
    invalidate: false,
  },

  {
    name: 'ИЗМЕНИТЬ ТИП ОПЛАТЫ',
    action: () => newAssignDealerDrawerStore.setIsChangePaymentOpen(true),
    icon: getImageSrc('typeSubsidy'),
    status: (status: number | null) => [1, 2].includes(status as number),
    invalidate: false,
  },

  {
    name: 'ДОБАВИТЬ В АРХИВ',
    action: () => {},
    icon: getImageSrc('to-archive'),
    status: (status: number | null) => [1].includes(status as number),
    invalidate: false,
  },
  {
    name: 'включить в проблемную зону',
    action: () => {},
    status: (status: number | null) => [1, 2, 4, 5].includes(status as number),
    invalidate: false,
  },
  {
    name: 'Исключить из проблемной зоны',
    action: () => {},
    status: (status: number | null) => [1, 2, 4, 5].includes(status as number),
    invalidate: false,
  },
]

export const dealerGroupOperations = () => [
  { name: 'ВЫБЕРИТЕ ДЕЙСТВИЕ', action: null, icon: null },
  {
    name: 'ПРИНЯТЬ ЗАЯВКИ',
    action: async (ids: number[]) => store.bulkAccept(ids),
    status: (status: number | null) => [2].includes(status as number),
    invalidate: true,
  },
  {
    name: 'включить в проблемную зону',
    action: () => {},
    status: (status: number | null) => [1, 2, 4, 5].includes(status as number),
    invalidate: false,
  },
  {
    name: 'Исключить из проблемной зоны',
    action: () => {},
    status: (status: number | null) => [1, 2, 4, 5].includes(status as number),
    invalidate: false,
  },
]

export const groupOperations = () => {
  if (isAdmin()) return adminGroupOperations()
  else return dealerGroupOperations()
}

export class GroupOperationsStore {
  value: string = groupOperations()[0].name
  selectChanged = false

  constructor() {
    makeAutoObservable(this)
  }

  setValue = (newValue: string) => {
    this.value = newValue
  }

  setSelectedChanged = (isChanged: boolean) => {
    this.selectChanged = isChanged
  }
}

export const groupOperationsStore = new GroupOperationsStore()
